import { ForumSource, FunctionCall } from "components/hooks/useTaskAgentState";
import { DefaultActionContainer } from "./DefaultActionDisplay";
import LinkRouter from "components/navigation/LinkRouter";
import TruncatedText from "components/common/TruncatedText";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useIsMobile from "components/hooks/useIsMobile";

export default ({
  call,
  displayName,
  accountType = "advisor",
}: {
  call: FunctionCall;
  displayName: string;
  accountType?: "advisor" | "member";
}) => {
  const isMobile = useIsMobile();
  const sources = (call.sources || []) as ForumSource[];
  const remainingCount = sources.length - 3;
  const [isExpanded, setIsExpanded] = useState(false);
  const displayedSources = isExpanded ? sources : sources.slice(0, 3);

  // For members, show generic message only
  if (accountType === "member") {
    // Backend may send source_count instead of sources array for members
    const count = (call as any).source_count || sources.length;
    return (
      <DefaultActionContainer
        call={call}
        displayName={displayName}
        actionSummary={
          count > 0
            ? `Read ${count} community post${count !== 1 ? "s" : ""}`
            : ""
        }
        hideChevron={sources.length === 0}
      />
    );
  }

  // For advisors, show full details
  return (
    <DefaultActionContainer
      defaultOpen={true}
      call={call}
      displayName={displayName}
      actionSummary={""}
      children={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            marginLeft: "24px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            {displayedSources.map((source, index) => (
              <div key={index}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "4px",
                    textWrap: "nowrap",
                  }}
                >
                  <LinkRouter
                    sx={{ padding: 0, width: isMobile ? "100%" : undefined }}
                    to={`/community/${encodeURIComponent(source.post_ref)}`}
                  >
                    <TruncatedText
                      variant="bodySmallHeavy"
                      color="#198282"
                      lines={1}
                    >
                      {source.title}
                    </TruncatedText>
                  </LinkRouter>
                  {!isMobile && (
                    <>
                      {" • "}
                      <LinkRouter
                        to={`/advisor/${encodeURIComponent(source.author_ref)}`}
                        sx={{
                          padding: 0,
                          fontSize: "14px",
                          color: "text.secondary",
                        }}
                      >
                        {source.author_name}
                      </LinkRouter>
                    </>
                  )}
                </Box>
                <TruncatedText variant="bodySmall" lines={1} color="#6B6E7B">
                  {source.relevance_explanation}
                </TruncatedText>
              </div>
            ))}
          </div>
          {remainingCount > 0 && (
            <Typography
              variant="bodySmallHeavy"
              sx={{ color: "text.secondary", cursor: "pointer" }}
              onClick={() => setIsExpanded(true)}
            >
              +{remainingCount} more
            </Typography>
          )}
        </div>
      }
    />
  );
};
